
import img1 from "../../assets/SeplWork/happynenapulogo.png";
import img2 from "../../assets/SeplWork/soochana.png";
import img3 from "../../assets/SeplWork/soochilogo.png";
import img4 from "../../assets/SeplWork/vicaas.png";
import img5 from "../../assets/SeplWork/sepllogo.png";

export const OUR_WORK_IMAGES = [
  img1,
  img2,
  img3,
  img4,
  img5
];
